import { render, staticRenderFns } from "./AlertDeviceBigIcon.vue?vue&type=template&id=6148f34e"
import script from "./AlertDeviceBigIcon.vue?vue&type=script&lang=js"
export * from "./AlertDeviceBigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports